<cass-core-toolbar></cass-core-toolbar>
<div class='page-container'>
	<mat-card class="branding--title-card">
		<mat-card-content>
			<h1>{{ "CHAT_MESSAGES.MESSAGES_PAGE.MAIN_TITLE" | translate }}</h1>
		</mat-card-content>
	</mat-card>
	<div class="chat-conversations-list-container">
		<app-chat-conversations-list [markMessageIdAsSelected]="selectedMessageId" (onMessageClick)="conversationSelected($event)" [class.full-space]="chatMessages.length === 0 && !(updatingMessages$ | async)"></app-chat-conversations-list>
		<ng-container *ngIf="!(updatingMessages$ | async); else loading">
			<div *ngIf="chatMessages.length > 0">
				<mat-card>
					<mat-card-header>
						<mat-card-title>{{ publisher?.label || "Not found - debug only" }}</mat-card-title>
					</mat-card-header>
					<mat-card-content>
						<app-chat-panel [messages]="chatMessages" [orderId]="orderId" [currentUserId]="currentUserId" [publisher]="publisher" [scrollToMessageId]="scrollToMessageId" (messageSent)="chatMessageSent($event)"></app-chat-panel>
					</mat-card-content>
				</mat-card>
			</div>
		</ng-container>
	</div>
</div>
<ng-template #loading>
	<cass-indeterminate-circular-progress-indicator></cass-indeterminate-circular-progress-indicator>
</ng-template>

